// Emoji utilities — extracted verbatim from InteractiveGraph.js (IG-split Slice 3).
// Pure, self-contained: label→emoji resolution (NUMBER_EMOJIS … getSmartEmojiForLabel)
// + emoji regex/strip helpers (EMOJI_PATTERN … stripEmojis). Moved byte-identical.
// Only getSmartEmojiForLabel / stripEmojis / startsWithEmoji are consumed outside this
// module (InteractiveGraph internals + ProblemTextPanel via IG re-export), so only those
// three are exported; the rest stay module-private, exactly as they were IG-private.

const NUMBER_EMOJIS = ['0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣', '🔟'];

const EMOJI_KEYWORD_ENTRIES = [
  { emoji: '🐱', keywords: ['cat', 'cats', 'kitty', 'kitten'], partials: ['猫', 'ねこ', 'ネコ'] },
  { emoji: '🐶', keywords: ['dog', 'dogs', 'puppy'], partials: ['犬', 'いぬ', 'イヌ'] },
  { emoji: '🐰', keywords: ['rabbit', 'rabbits', 'bunny'], partials: ['うさぎ', 'ウサギ', '兎'] },
  { emoji: '🐦', keywords: ['bird', 'birds', 'sparrow', 'parrot'], partials: ['鳥', 'トリ', 'とり'] },
  { emoji: '🐟', keywords: ['fish', 'salmon', 'tuna'], partials: ['魚', 'さかな', 'サカナ'] },
  { emoji: '🐹', keywords: ['hamster'], partials: ['ハムスター'] },
  { emoji: '🐢', keywords: ['turtle', 'tortoise'], partials: ['亀', 'カメ', 'かめ'] },
  { emoji: '🐻', keywords: ['bear', 'bears'], partials: ['熊', 'クマ', 'くま'] },
  { emoji: '🐼', keywords: ['panda', 'pandas'], partials: ['パンダ'] },
  { emoji: '🦊', keywords: ['fox', 'foxes'], partials: ['狐', 'キツネ', 'きつね'] },
  { emoji: '🐸', keywords: ['frog', 'frogs'], partials: ['蛙', 'カエル', 'かえる'] },
  { emoji: '🦁', keywords: ['lion', 'lions'], partials: ['ライオン'] },
  { emoji: '🐴', keywords: ['horse', 'horses'], partials: ['馬', 'ウマ', 'うま'] },
  { emoji: '🐮', keywords: ['cow', 'cows', 'cattle'], partials: ['牛', 'ウシ', 'うし'] },
  { emoji: '🐷', keywords: ['pig', 'pigs'], partials: ['豚', 'ブタ', 'ぶた'] },
  { emoji: '🐔', keywords: ['chicken', 'chick'], partials: ['鶏', 'ニワトリ', 'ひよこ', 'ヒヨコ'] },
  { emoji: '🐧', keywords: ['penguin', 'penguins'], partials: ['ペンギン'] },
  { emoji: '🍎', keywords: ['apple', 'apples'], partials: ['りんご', 'リンゴ', '林檎'] },
  { emoji: '🍌', keywords: ['banana', 'bananas'], partials: ['バナナ'] },
  { emoji: '🍊', keywords: ['orange', 'oranges', 'mandarin'], partials: ['みかん', 'ミカン', 'オレンジ'] },
  { emoji: '🍓', keywords: ['strawberry', 'strawberries'], partials: ['いちご', 'イチゴ'] },
  { emoji: '🍇', keywords: ['grape', 'grapes'], partials: ['ぶどう', 'ブドウ'] },
  { emoji: '🍉', keywords: ['watermelon', 'melons'], partials: ['すいか', 'スイカ'] },
  { emoji: '🍚', keywords: ['rice', 'gohan', 'meal'], partials: ['ごはん', 'ご飯', '米'] },
  { emoji: '🍞', keywords: ['bread', 'loaf'], partials: ['パン'] },
  { emoji: '🍰', keywords: ['cake', 'dessert', 'sweets'], partials: ['ケーキ'] },
  { emoji: '🍕', keywords: ['pizza'], partials: [] },
  { emoji: '🚗', keywords: ['car', 'cars', 'auto'], partials: ['車', 'くるま', 'クルマ'] },
  { emoji: '🚌', keywords: ['bus', 'buses'], partials: ['バス'] },
  { emoji: '🚆', keywords: ['train', 'trains'], partials: ['電車', 'でんしゃ', 'デンシャ'] },
  { emoji: '🚲', keywords: ['bike', 'bicycle'], partials: ['自転車', 'じてんしゃ', 'ジテンシャ'] },
  { emoji: '✈️', keywords: ['airplane', 'plane', 'flight'], partials: ['飛行機', 'ひこうき', 'ヒコウキ'] },
  { emoji: '⛵', keywords: ['boat', 'ship', 'sail'], partials: ['船', 'ふね', 'フネ'] },
  { emoji: '🌸', keywords: ['spring', 'march', 'april'], partials: ['春', '3月', '３月', '4月', '４月'] },
  { emoji: '☀️', keywords: ['summer', 'july', 'august'], partials: ['夏', '7月', '７月', '8月', '８月'] },
  { emoji: '🍁', keywords: ['autumn', 'fall', 'september', 'october', 'november'], partials: ['秋', '9月', '９月', '10月', '１０月', '11月', '１１月'] },
  { emoji: '⛄', keywords: ['winter', 'december', 'january', 'february'], partials: ['冬', '12月', '１２月', '1月', '１月', '2月', '２月'] },
  { emoji: '☀️', keywords: ['sun', 'sunny'], partials: ['晴', 'はれ'] },
  { emoji: '☁️', keywords: ['cloud', 'cloudy'], partials: ['曇', 'くもり'] },
  { emoji: '🌧️', keywords: ['rain', 'rainy', 'rainfall'], partials: ['雨', 'あめ'] },
  { emoji: '❄️', keywords: ['snow', 'snowy'], partials: ['雪', 'ゆき'] },
  { emoji: '💨', keywords: ['wind', 'windy'], partials: ['風', 'かぜ'] },
  { emoji: '⚡', keywords: ['storm', 'thunder', 'lightning'], partials: ['雷', 'かみなり'] },
  { emoji: '⚽', keywords: ['soccer', 'football'], partials: ['サッカー'] },
  { emoji: '⚾', keywords: ['baseball'], partials: ['野球', 'やきゅう'] },
  { emoji: '🏀', keywords: ['basketball'], partials: ['バスケ', 'バスケット'] },
  { emoji: '🎾', keywords: ['tennis'], partials: ['テニス'] },
  { emoji: '🏊', keywords: ['swim', 'swimming'], partials: ['水泳', 'すいえい'] },
  { emoji: '🏃', keywords: ['run', 'running', 'marathon'], partials: ['マラソン', 'かけっこ', '走'] },
  { emoji: '🏐', keywords: ['volleyball'], partials: ['バレー', 'バレーボール'] },
  { emoji: '😊', keywords: ['happy', 'glad', 'smile'], partials: ['うれしい', '嬉しい'] },
  { emoji: '😢', keywords: ['sad', 'cry', 'tears'], partials: ['かなしい', '悲しい'] },
  { emoji: '😠', keywords: ['angry', 'mad'], partials: ['怒る', 'おこる'] },
  { emoji: '😲', keywords: ['surprised', 'surprise'], partials: ['驚', 'びっくり'] },
  { emoji: '🤩', keywords: ['excited', 'awesome'], partials: ['わくわく', 'ワクワク'] },
  { emoji: '😰', keywords: ['nervous', 'worried'], partials: ['心配'] },
  { emoji: '😴', keywords: ['sleepy', 'tired'], partials: ['ねむい', '眠い'] },
  { emoji: '📖', keywords: ['language', 'japanese', 'reading', 'kokugo'], partials: ['国語'] },
  { emoji: '➕', keywords: ['math', 'arithmetic', '算数', 'すうがく', 'maths'], partials: ['算数', '数学'] },
  { emoji: '🔤', keywords: ['english'], partials: ['英語'] },
  { emoji: '🔬', keywords: ['science'], partials: ['理科'] },
  { emoji: '🌏', keywords: ['social', 'society', 'civics'], partials: ['社会'] },
  { emoji: '🎵', keywords: ['music'], partials: ['音楽'] },
  { emoji: '🏃', keywords: ['pe', 'gym', 'physical education'], partials: ['体育'] },
  { emoji: '🎨', keywords: ['art', 'drawing'], partials: ['美術', '図工'] },
  { emoji: '📜', keywords: ['history'], partials: ['歴史'] },
  { emoji: '🗺️', keywords: ['geography', 'geo'], partials: ['地理'] },
  { emoji: '⚗️', keywords: ['chemistry', 'chem'], partials: ['化学'] },
  { emoji: '⚛️', keywords: ['physics'], partials: ['物理'] },
  { emoji: '🧬', keywords: ['biology', 'bio'], partials: ['生物'] },
  { emoji: '🔧', keywords: ['tech', 'technology', 'engineering'], partials: ['技術'] },
  { emoji: '🍳', keywords: ['home economics', 'cooking', 'homeec'], partials: ['家庭科'] },
  { emoji: '👧', keywords: ['girl', 'girls'], partials: ['女子', '少女'] },
  { emoji: '👦', keywords: ['boy', 'boys'], partials: ['男子', '少年'] },
  { emoji: '🎯', keywords: ['goal', 'target', 'aim'], partials: ['目標'] },
  { emoji: '💡', keywords: ['idea', 'hint'], partials: ['ヒント', 'ポイント'] },
  { emoji: '📅', keywords: ['schedule', 'calendar', 'day'], partials: ['日程', '予定'] },
  { emoji: '📚', keywords: ['study', 'lesson', 'class'], partials: ['授業', '学習'] }
];

const EXACT_EMOJI_KEYWORDS = new Map();
const PARTIAL_EMOJI_KEYWORDS = [];

EMOJI_KEYWORD_ENTRIES.forEach(({ emoji, keywords = [], partials = [] }) => {
  keywords.forEach((keyword) => {
    if (!keyword) return;
    EXACT_EMOJI_KEYWORDS.set(keyword.toLowerCase(), emoji);
  });
  partials.forEach((keyword) => {
    if (!keyword) return;
    PARTIAL_EMOJI_KEYWORDS.push({ keyword: keyword.toLowerCase(), emoji });
  });
});

const EMOJI_FALLBACK_PATTERNS = [
  { pattern: /(boy|male|男子|men|少年)/i, emoji: '👦' },
  { pattern: /(girl|female|女子|women|少女)/i, emoji: '👧' },
  { pattern: /(time|時間|hour|min|秒)/i, emoji: '⏱️' },
  { pattern: /(temperature|気温|climate|℃|度)/i, emoji: '🌡️' },
  { pattern: /(population|人数|参加者|人)/i, emoji: '👥' },
  { pattern: /(weather|天気|気象)/i, emoji: '⛅' },
  { pattern: /(target|goal|目標)/i, emoji: '🎯' },
  { pattern: /(complete|finish|達成|クリア)/i, emoji: '✅' },
  { pattern: /(attention|focus|注目|フォーカス|注視)/i, emoji: '👀' }
];

const numberToEmoji = (value) => {
  if (Number.isInteger(value) && value >= 0 && value <= 10) {
    return NUMBER_EMOJIS[value];
  }
  return null;
};

const getNumberEmojiFromLabel = (label) => {
  const pureDigits = label.match(/^\d+$/);
  if (pureDigits) {
    const emoji = numberToEmoji(Number(pureDigits[0]));
    if (emoji) return emoji;
  }
  const ordinalMatch = label.match(/^第?(\d+)(?:[^\d]{0,3})?$/);
  if (ordinalMatch) {
    const emoji = numberToEmoji(Number(ordinalMatch[1]));
    if (emoji) return emoji;
  }
  return null;
};

const getSmartEmojiForLabel = (rawInput = '', options = {}) => {
  if (options && typeof options === 'object' && options.emoji) {
    return options.emoji;
  }

  let baseValue = rawInput;
  if (rawInput && typeof rawInput === 'object' && !Array.isArray(rawInput)) {
    const directEmoji = rawInput.emoji || rawInput.icon || rawInput.symbol;
    if (directEmoji) {
      return directEmoji;
    }
    baseValue = rawInput.label || rawInput.barLabel || rawInput.seriesName || rawInput.name || rawInput.value || rawInput.id || '';
  }

  if (baseValue === undefined || baseValue === null) {
    return '🔹';
  }

  const label = baseValue.toString().trim();
  if (!label.length) {
    return '🔹';
  }

  const normalized = label.toLowerCase();
  if (EXACT_EMOJI_KEYWORDS.has(normalized)) {
    return EXACT_EMOJI_KEYWORDS.get(normalized);
  }

  for (const { keyword, emoji } of PARTIAL_EMOJI_KEYWORDS) {
    if (keyword && normalized.includes(keyword)) {
      return emoji;
    }
  }

  const numberEmoji = getNumberEmojiFromLabel(label);
  if (numberEmoji) {
    return numberEmoji;
  }

  for (const preset of EMOJI_FALLBACK_PATTERNS) {
    if (preset.pattern.test(label)) {
      return preset.emoji;
    }
  }

  if (/%/.test(label)) return '📈';
  if (/¥|円|dollar|usd|price|cost|fee/i.test(label)) return '💰';
  if (/total|合計|全部|sum|平均|average/i.test(label)) {
    return /平均|average/i.test(label) ? '⚖️' : '📊';
  }
  if (/[A-Za-z]/.test(label) && /[0-9]/.test(label)) return '🔭';
  if (label.length <= 2) return '🔸';
  return '🔹';
};

const EMOJI_PATTERN = "[\\u{1F300}-\\u{1F5FF}\\u{1F600}-\\u{1F64F}\\u{1F680}-\\u{1F6FF}\\u{1F1E0}-\\u{1F1FF}\\u{2600}-\\u{27BF}\\u{1F900}-\\u{1F9FF}\\u{1FA70}-\\u{1FAFF}]";
const EMOJI_REGEX = new RegExp(EMOJI_PATTERN, 'gu');
const LEADING_EMOJI_REGEX = new RegExp(`^${EMOJI_PATTERN}`, 'u');

const startsWithEmoji = (text = '') => {
  if (!text) return false;
  return LEADING_EMOJI_REGEX.test(text.trim());
};

const stripEmojis = (text = '') => text.replace(EMOJI_REGEX, '');

export { getSmartEmojiForLabel, stripEmojis, startsWithEmoji };
